import React, {Component} from 'react';
import './App.scss'
import Header from "./container/header/header";
import About from "./container/about/about";
import Work from "./container/work/work";
import Skills from "./container/skills/skills";
import Testimonials from "./container/testimonials/testimonials";
import Footer from "./container/footer/footer";
import Navbar from "./components/navbar/navbar";

class App extends Component {
    render() {
        return (
            <div className="app">
                <Navbar/>
                <Header/>
                <About/>
                <Work/>
                <Skills/>
                <Testimonials/>
                <Footer/>
            </div>
        );
    }
}

export default App;